import React from 'react'
import injectSheet from 'react-jss'
import styles from './back-link.styles'
import { Link } from 'react-router-dom'
import CaretLeft from 'react-icons/lib/fa/caret-left'

const Intro = ({ classes, url, link, match }) => {
  return match.params.workId ? (
    <Link to={url} className={classes.back}>
      <CaretLeft /> {link}
    </Link>
  ) : (
    <Link to={url} className={classes.back}>
      <CaretLeft /> {link}
    </Link>
  )
}

export default injectSheet(styles)(Intro)
